import i18nFactory from '@yandex-int/i18n';
import { get } from 'lodash';

import { ValidationResultItem } from '../../../typings/common';
import { createErrorsMapper } from '../../ErrorsMapper/ErrorsMapper';

import * as keyset from './VCardsErrors.i18n';

const i18n = i18nFactory(keyset);

export const VCardErrorMapper = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: ['vcardAddItems', idx],
            codes: [
                {
                    code: 'NEED_TO_SAVE',
                    message: (): string => {
                        return i18n('vcard-need-to-save');
                    }
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'companyName'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-name-no-empty')
                },
                {
                    code:
                        'DefectIds.MUST_CONTAIN_LETTERS_OR_DIGITS_OR_PUNCTUATIONS',
                    message: (): string => i18n('vcard-name-letters')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-name-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'contactPerson'],
            codes: [
                {
                    code:
                        'DefectIds.MUST_CONTAIN_LETTERS_OR_DIGITS_OR_PUNCTUATIONS',
                    message: (): string => i18n('vcard-name-letters')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-name-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'ogrn'],
            codes: [
                {
                    code: 'OgrnConstraint.VoidDefectIds.INVALID_OGRN',
                    message: (): string => i18n('vcard-ogrn-format')
                },
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-ogrn-no-empty')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'email'],
            codes: [
                {
                    code:
                        'AddVcardValidationService.VoidDefectIds.CONTACT_EMAIL_INVALID_FORMAT',
                    message: (): string => i18n('vcard-mail-format')
                },
                {
                    code: 'VoidDefectIds.CONTACT_EMAIL_IS_EMPTY',
                    message: (): string => i18n('vcard-mail-no-empty')
                },
                {
                    code: 'VoidDefectIds.CONTACT_EMAIL_INVALID_FORMAT',
                    message: (): string => i18n('vcard-mail-format')
                },
                {
                    code:
                        'AddVcardValidationService.StringLengthDefectIds.CONTACT_EMAIL_TOO_LONG',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-mail-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'address', 'country'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-country-no-empty')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-country-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'DefectIds.MUST_CONTAIN_LETTERS',
                    message: (): string => i18n('vcard-country-letters')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'address', 'city'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-city-no-empty')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-city-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'DefectIds.MUST_CONTAIN_LETTERS',
                    message: (): string => i18n('vcard-city-letters')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'address', 'street'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-street-no-empty')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-street-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'DefectIds.MUST_CONTAIN_LETTERS_OR_DIGITS_OR_PUNCTUATIONS',
                    message: (): string => i18n('vcard-street-letters')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'address', 'houseWithBuilding'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-house-no-empty')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-house-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'address', 'apartment'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-office-no-empty')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-office-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'DefectIds.MUST_CONTAIN_LETTERS_OR_DIGITS_OR_PUNCTUATIONS',
                    message: (): string => i18n('vcard-office-format')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'phone', 'countryCode'],
            codes: [
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.COUNTRY_CODE_IS_EMPTY',
                    message: (): string =>
                        i18n('vcard-phone-country-code-no-empty')
                },
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.COUNTRY_CODE_IS_TOO_LONG',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-phone-country-code-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'PhoneValidator.VoidDefectIds.COUNTRY_CODE_FORMAT_IS_INVALID',
                    message: (): string =>
                        i18n('vcard-phone-country-code-format')
                },
                {
                    code:
                        'PhoneValidator.VoidDefectIds.COUNTRY_CODE_MUST_START_WITH_PLUS',
                    message: (): string =>
                        i18n('vcard-phone-country-code-start-plus')
                },
                {
                    code:
                        'PhoneValidator.CityCodeDefectIds.COUNTRY_CODE_MUST_NOT_START_WITH_PLUS',
                    message: (): string =>
                        i18n('vcard-phone-country-code-start-no-plus')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'phone', 'cityCode'],
            codes: [
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.CITY_CODE_IS_EMPTY',
                    message: (): string =>
                        i18n('vcard-phone-city-code-no-empty')
                },
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.CITY_CODE_IS_TOO_LONG',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-phone-city-code-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'PhoneValidator.VoidDefectIds.CITY_CODE_FORMAT_IS_INVALID',
                    message: (): string => i18n('vcard-phone-city-code-format')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'phone', 'phoneNumber'],
            codes: [
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.PHONE_NUMBER_IS_EMPTY',
                    message: (): string => i18n('vcard-phone-number-no-empty')
                },
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.PHONE_NUMBER_IS_TOO_SHORT',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-phone-number-min-length', {
                            minLength: get(err, 'params.minLength', '')
                        });
                    }
                },
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.PHONE_NUMBER_IS_TOO_LONG',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-phone-number-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'PhoneValidator.VoidDefectIds.PHONE_NUMBER_FORMAT_IS_INVALID',
                    message: (): string => i18n('vcard-phone-number-format')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'phone', 'extension'],
            codes: [
                {
                    code:
                        'PhoneValidator.VoidDefectIds.EXTENSION_FORMAT_IS_INVALID',
                    message: (): string => i18n('vcard-phone-extension-format')
                },
                {
                    code:
                        'PhoneValidator.StringLengthDefectIds.EXTENSION_IS_TOO_LONG',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-phone-extension-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'instantMessenger', 'login'],
            codes: [
                {
                    code:
                        'InstantMessengerValidator.StringDefectIds.LOGIN_IS_TOO_LONG',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-messenger-login-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'InstantMessengerValidator.VoidDefectIds.INVALID_ICQ_LOGIN_FORMAT',
                    message: (): string => i18n('vcard-messenger-icq-format')
                },
                {
                    code:
                        'InstantMessengerValidator.VoidDefectIds.INVALID_JABBER_LOGIN_FORMAT',
                    message: (): string => i18n('vcard-messenger-jabber-format')
                },
                {
                    code:
                        'InstantMessengerValidator.VoidDefectIds.INVALID_MAIL_AGENT_LOGIN_FORMAT',
                    message: (): string =>
                        i18n('vcard-messenger-mailruagent-format')
                },
                {
                    code:
                        'InstantMessengerValidator.VoidDefectIds.INVALID_SKYPE_OR_MSN_LOGIN_FORMAT',
                    message: (): string =>
                        i18n('vcard-messenger-skype-or-msn-format')
                }
            ]
        },
        {
            path: ['vcardAddItems', idx, 'extraMessage'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (): string => i18n('vcard-descr-no-empty')
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('vcard-descr-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'DefectIds.MUST_CONTAIN_LETTERS_OR_DIGITS_OR_PUNCTUATIONS',
                    message: (): string => i18n('vcard-descr-format')
                }
            ]
        }
    ],
    error => i18n('vcard-error-text', { path: error.path, code: error.code })
);
